//Author June Leow
//Date Mar 25th, 2024
import {getReducer, getSetStateFunction, deleteAPICallGenerator, callBackGenerator, generateTooltip, showMessage} from '../../../../util/util';
import {Card, CardHeader, CardBody, Input} from 'reactstrap';
import Compressor from 'compressorjs';
import Dropzone from 'react-dropzone'
import MySelect from '../../../util/my-select';
import React, {useReducer, useEffect} from 'react';
//initialize the state
const initialState = {

};


const mechanicalDeficiencyNameEnum = [
  {value:'NONE_OBSERVED', label:'None Observed'},
  {value:'PLUMBING', label:'Plumbing'},
  {value:'ELECTRICAL', label:'Electrical'},
  {value:'HEATING', label:'Heating'},
  {value:'WATER_HEATER', label:'Water Heater'},
  {value:'COOLING', label:'Cooling'},
  {value:'SUMP_PUMP', label:'Sump Pump'},
  {value:'OTHER', label:'Other'},
]

const mechanicalDeficiencyTypeEnum = [
  {value:'EXCESSIVE_WEAR', label:'Excessive Wear'},
  {value:'DAMAGE', label:'Damage'},
  {value:'MISSING', label:'Missing'},
  {value:'NON_FUNCTIONAL', label:'Non Functional'},
  {value:'EVIDENCE_OF_LEAKS', label:'Evidence of Leaks'},
  {value:'EVIDENCE_OF_FIRE', label:'Evidence of Fire'},
  {value:'OTHER', label:'Other'},
]

const mechanicalUpdatedComponentEnum = [
  {value:'PLUMBING', label:'Plumbing'},
  {value:'ELECTRICAL', label:'Electrical'},
  {value:'HEATING', label:'Heating'},
  {value:'WATER_HEATER', label:'Water Heater'},
  {value:'COOLING', label:'Cooling'},
  {value:'SUMP_PUMP', label:'Sump Pump'},
  {value:'OTHER', label:'Other'},
  {value:'NONE_OBSERVED', label:'None Observed'}
]

const mechanicalUpdateTypeEnum = [
  {value:'FULLY_UPDATED', label:'Fully Updated'},
  {value:'PARTIALLY_UPDATED', label:'Partially Updated'}
]

const mechanicalUpdateTimeframeEnum = [
  {value:'LESS_THAN_1_YEAR', label:'Less than 1 year'},
  {value:'1_TO_5_YEARS', label:'1 to 5 years'},
  {value:'5_TO_10_YEARS', label:'5 to 10 years'},
  {value:'10_OR_MORE_YEARS', label:'10 or more years'}
]
 

const disabledStyling = {border:'none', background:'#fff', padding:'0',paddingLeft:'2px', height:'auto',WebkitAppearance:'none'};


//reducer function that perform state update
const reducer = getReducer();


const Mechanicals  = (props)=>{
  const controller = new AbortController();

  const [, dispatch] = useReducer(reducer,initialState);

  //wrapper function
  const setState = getSetStateFunction(dispatch);

  const apiCallBack = callBackGenerator(setState);
  const httpDelete = deleteAPICallGenerator(props, {signal:controller.signal});

  //run only once when component is loaded
  useEffect(()=>{
    return ()=> controller.abort();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);

  //non API call but simpyl manage state
  
  const getCompressRatio=(size)=>{
    let ratio = 0.8;
    size = size/1000/1000;
  
    if(size>=20)
      ratio = 0.05;
    else if(size>=15)
      ratio = 0.05;
    else if(size>=10)
      ratio = 0.1;
    else if(size>=8)
      ratio = 0.2;
    else if(size>=6)
      ratio = 0.4;
    else if(size>=4)
      ratio = 0.5;
    else if(size>=3)
      ratio = 0.6;
    else if(size>=2)
      ratio = 0.7;
  
    return ratio;
  }

  //function trigger for dropzone react.
  //this function contians two list of files, the accepted and rejected file per the configuration
  const onDrop=(acceptedFiles, rejectedFiles, index, field, type='Misc', typeFk=0, description='')=>{

    let existingFiles = [];
    if(acceptedFiles.length>0){
      for(let i=0;i<acceptedFiles.length;i++){
        existingFiles.push(acceptedFiles[i]);
        let name = existingFiles[i].name;
        let token = name.split('.');
        let extension = '';

        if(token.length>0){
          extension = token[token.length-1];
          extension = extension.toLowerCase();
        }

        if(extension!=='png'&&extension!=='jpg'&&extension!=='jpeg'){
          showMessage('error','Please upload only PNG/JPG image.');
        }
        else if((acceptedFiles[i].size/1000/1000)<1){
          showMessage('error','Image quality is too low, please use photo that range from 1MB to 50MB.');
        }
        else if((acceptedFiles[i].size/1000/1000)>50){
          showMessage('error','Image size is too large, please use photo that range from 1MB to 50MB.');
        }
        else{
          let compressRatio = getCompressRatio(acceptedFiles[i].size);
          new Compressor(acceptedFiles[i], {
            quality: compressRatio, // 0.6 can also be used, but its not recommended to go below.
            success: (compressedResult) => {
              // compressedResult has the compressed file.
              // Use the compressed file to upload the images to your server.        
              let compressedFile = new File([compressedResult], acceptedFiles[i].name);

              const reader = new FileReader();
              reader.onload = () => {
                const fileAsBinaryString = reader.result;
                let base64 = btoa(fileAsBinaryString);
                let newUPD = Object.assign({}, props.upd);
                let mechanicalDeficiencies = newUPD.property.buildings[props.index].units[props.index2].mechanicalDeficiencies?newUPD.property.buildings[props.index].units[props.index2].mechanicalDeficiencies.slice():null;
   
                let target = mechanicalDeficiencies[index][field]?mechanicalDeficiencies[index][field]:[];
  
                target.push({name:acceptedFiles[i].name, base64:base64, status:'Pending', size:compressedFile.size, type:type, typeFk:mechanicalDeficiencies[index].ID, description:description});
                mechanicalDeficiencies[index][field] = target;
                newUPD.property.buildings[props.index].units[props.index2].mechanicalDeficiencies = mechanicalDeficiencies;
                props.update(newUPD);
              }
              reader.readAsBinaryString(compressedFile);
            },
          });
        }
      }
    }
  }

  const updateFileDescription=(index, index2, field, description)=>{
    let newUPD = Object.assign({}, props.upd);
    let mechanicalDeficiencies = newUPD.property.buildings[props.index].units[props.index2].mechanicalDeficiencies?newUPD.property.buildings[props.index].units[props.index2].mechanicalDeficiencies.slice():null;
    let target = mechanicalDeficiencies[index][field]?mechanicalDeficiencies[index][field]:[];
    if(target &&  target[index2]){
      target[index2].description = description;
    }

    newUPD.property.buildings[props.index].units[props.index2].mechanicalDeficiencies = mechanicalDeficiencies;
    props.update(newUPD);
  }

  const updateFileDescription2=(index, index2, field, description)=>{
    let newUPD = Object.assign({}, props.upd);
    let mechanicalUpdates = newUPD.property.buildings[props.index].units[props.index2].mechanicalUpdates?newUPD.property.buildings[props.index].units[props.index2].mechanicalUpdates.slice():null;
    let target = mechanicalUpdates[index][field]?mechanicalUpdates[index][field]:[];
    if(target &&  target[index2]){
      target[index2].description = description;
    }

    newUPD.property.buildings[props.index].units[props.index2].mechanicalUpdates = mechanicalUpdates;
    props.update(newUPD);
  }

  const removeFile=(field,index, index2)=>{
    let newUPD = Object.assign({}, props.upd);
    let mechanicalDeficiencies = newUPD.property.buildings[props.index].units[props.index2].mechanicalDeficiencies.slice();
    let target = mechanicalDeficiencies[index][field].slice();

    let targetToDelete = target[index2];

    if(targetToDelete.ID && targetToDelete.ID!==-1){
      let successCallBack = ()=>{
        target.splice(index2, 1);
        mechanicalDeficiencies[index][field] = target;
        newUPD.property.buildings[props.index].units[props.index2].mechanicalDeficiencies = mechanicalDeficiencies;
        props.update(newUPD);
      };
      successCallBack = successCallBack.bind(this);
      deletePhoto(targetToDelete.ID, props, successCallBack);
    }
    else{
      target.splice(index2, 1);
      mechanicalDeficiencies[index][field] = target;
      newUPD.property.buildings[props.index].units[props.index2].mechanicalDeficiencies = mechanicalDeficiencies;
      props.update(newUPD);
    }
  }

  //function trigger for dropzone react.
  //this function contians two list of files, the accepted and rejected file per the configuration
  const onDrop2=(acceptedFiles, rejectedFiles, index, field, type='Misc', typeFk=0, description='')=>{
    let existingFiles = [];
    if(acceptedFiles.length>0){
      for(let i=0;i<acceptedFiles.length;i++){
        existingFiles.push(acceptedFiles[i]);
        let name = existingFiles[i].name;
        let token = name.split('.');
        let extension = '';

        if(token.length>0){
          extension = token[token.length-1];
          extension = extension.toLowerCase();
        }

        if(extension!=='png'&&extension!=='jpg'&&extension!=='jpeg'){
          showMessage('error','Please upload only PNG/JPG image.');
        }
        else if((acceptedFiles[i].size/1000/1000)<1){
          showMessage('error','Image quality is too low, please use photo that range from 1MB to 50MB.');
        }
        else if((acceptedFiles[i].size/1000/1000)>50){
          showMessage('error','Image size is too large, please use photo that range from 1MB to 50MB.');
        }
        else{
          let compressRatio = getCompressRatio(acceptedFiles[i].size);
          new Compressor(acceptedFiles[i], {
            quality: compressRatio, // 0.6 can also be used, but its not recommended to go below.
            success: (compressedResult) => {
              // compressedResult has the compressed file.
              // Use the compressed file to upload the images to your server.        
              let compressedFile = new File([compressedResult], acceptedFiles[i].name);

              const reader = new FileReader();
              reader.onload = () => {
                const fileAsBinaryString = reader.result;
                let base64 = btoa(fileAsBinaryString);
                let newUPD = Object.assign({}, props.upd);
                let mechanicalUpdates = newUPD.property.buildings[props.index].units[props.index2].mechanicalUpdates?newUPD.property.buildings[props.index].units[props.index2].mechanicalUpdates.slice():null;
   
                let target = mechanicalUpdates[index][field]?mechanicalUpdates[index][field]:[];
  
                target.push({name:acceptedFiles[i].name, base64:base64, status:'Pending', size:compressedFile.size, type:type, typeFk:mechanicalUpdates[index].ID, description:description});
                mechanicalUpdates[index][field] = target;
                newUPD.property.buildings[props.index].units[props.index2].mechanicalUpdates = mechanicalUpdates;
                props.update(newUPD);
              }
              reader.readAsBinaryString(compressedFile);
            },
          });
        }
      }
    }
  }

  const removeFile2=(field,index, index2)=>{
    let newUPD = Object.assign({}, props.upd);
    let mechanicalUpdates = newUPD.property.buildings[props.index].units[props.index2].mechanicalUpdates.slice();
    let target = mechanicalUpdates[index][field].slice();

    let targetToDelete = target[index2];

    if(targetToDelete.ID && targetToDelete.ID!==-1){
      let successCallBack = ()=>{
        target.splice(index2, 1);
        mechanicalUpdates[index][field] = target;
        newUPD.property.buildings[props.index].units[props.index2].mechanicalUpdates = mechanicalUpdates;
        props.update(newUPD);
      };
      successCallBack = successCallBack.bind(this);
      deletePhoto(targetToDelete.ID, props, successCallBack);
    }
    else{
      target.splice(index2, 1);
      mechanicalUpdates[index][field] = target;
      newUPD.property.buildings[props.index].units[props.index2].mechanicalUpdates = mechanicalUpdates;
      props.update(newUPD);
    }
  }

  const getMechanicalDeficiencyNameLabel=(value)=>{
    for(let i=0;i<mechanicalDeficiencyNameEnum.length;i++){
      if(mechanicalDeficiencyNameEnum[i].value===value)
        return mechanicalDeficiencyNameEnum[i].label;
    }

    return value;
  }

  const getMechanicalUpdatedComponentLabel=(value)=>{
    for(let i=0;i<mechanicalUpdatedComponentEnum.length;i++){
      if(mechanicalUpdatedComponentEnum[i].value===value)
        return mechanicalUpdatedComponentEnum[i].label;
    }

    return value;
  }

  const removeMechanicalDeficiency=(index)=>{
    let newUPD = Object.assign({}, props.upd);
    let mechanicalDeficiencies = newUPD.property.buildings[props.index].units[props.index2].mechanicalDeficiencies?newUPD.property.buildings[props.index].units[props.index2].mechanicalDeficiencies.slice():null;
    mechanicalDeficiencies.splice(index, 1);
    newUPD.property.buildings[props.index].units[props.index2].mechanicalDeficiencies = mechanicalDeficiencies;
    props.update(newUPD);
  }

  const removeMechanicalUpdate=(index)=>{
    let newUPD = Object.assign({}, props.upd);
    let mechanicalUpdates = newUPD.property.buildings[props.index].units[props.index2].mechanicalUpdates?newUPD.property.buildings[props.index].units[props.index2].mechanicalUpdates.slice():null;
    mechanicalUpdates.splice(index, 1);
    newUPD.property.buildings[props.index].units[props.index2].mechanicalUpdates = mechanicalUpdates;
    props.update(newUPD);
  }

  const updateMechanicalDeficiencyDetail=(index, field, value)=>{
    let newUPD = Object.assign({}, props.upd);
    let mechanicalDeficiencies = newUPD.property.buildings[props.index].units[props.index2].mechanicalDeficiencies?newUPD.property.buildings[props.index].units[props.index2].mechanicalDeficiencies.slice():null;
    mechanicalDeficiencies[index][field] = value;
    newUPD.property.buildings[props.index].units[props.index2].mechanicalDeficiencies = mechanicalDeficiencies;
    props.update(newUPD);
  }

  const updateMechanicalUpdateDetail=(index, field, value)=>{
    let newUPD = Object.assign({}, props.upd);
    let mechanicalUpdates = newUPD.property.buildings[props.index].units[props.index2].mechanicalUpdates?newUPD.property.buildings[props.index].units[props.index2].mechanicalUpdates.slice():null;
    mechanicalUpdates[index][field] = value;
    newUPD.property.buildings[props.index].units[props.index2].mechanicalUpdates = mechanicalUpdates;
    props.update(newUPD);
  }

  const updateMechanicalDeficiency=(value)=>{
    let newUPD = Object.assign({}, props.upd);
    let mechanicalDeficiencies = newUPD.property.buildings[props.index].units[props.index2].mechanicalDeficiencies?newUPD.property.buildings[props.index].units[props.index2].mechanicalDeficiencies.slice():null;
    
    if(value==='NONE_OBSERVED'){
      mechanicalDeficiencies = [{mechanicalDeficiencyName:'NONE_OBSERVED'}];
    }
    else{
      for(let i=0;i<mechanicalDeficiencies.length;i++){
        if(mechanicalDeficiencies[i].mechanicalDeficiencyName==='NONE_OBSERVED'){
          mechanicalDeficiencies = [];
          break;
        }
      }
      mechanicalDeficiencies.push({mechanicalDeficiencyName:value, imageMechanicalDeficiency:[]});
    }

    newUPD.property.buildings[props.index].units[props.index2].mechanicalDeficiencies = mechanicalDeficiencies;
    props.update(newUPD);
  }

  const updateMechanicalUpdate=(value)=>{
    let newUPD = Object.assign({}, props.upd);
    let mechanicalUpdates = newUPD.property.buildings[props.index].units[props.index2].mechanicalUpdates?newUPD.property.buildings[props.index].units[props.index2].mechanicalUpdates.slice():null;
    
    if(value==='NONE_OBSERVED'){
      mechanicalUpdates = [{mechanicalUpdatedComponent:'NONE_OBSERVED'}];
    }
    else{
      for(let i=0;i<mechanicalUpdates.length;i++){
        if(mechanicalUpdates[i].mechanicalUpdatedComponent==='NONE_OBSERVED'){
          mechanicalUpdates = [];
          break;
        }
      }
      mechanicalUpdates.push({mechanicalUpdatedComponent:value,imageMechanicalUpdate:[]});
    }

    newUPD.property.buildings[props.index].units[props.index2].mechanicalUpdates = mechanicalUpdates;
    props.update(newUPD);
  }

  //API call
  const deletePhoto = (ID, props, successCallBack) => {
    let callBack = apiCallBack([],[()=>{successCallBack()}])
    httpDelete('uniformPropertyDataset/photo/'+ID, '', 'Oops, something went wrong and could not delete this photo. Please try again later.', callBack);
  }
  
  //render
  return <div>
    <label>{!props.disabled?<font color="red">*</font>:null}Identify if there are mechanical component(s) or system(s) with obvious damage or wear requiring repairs? {generateTooltip('mechanicalDeficiencyName', 'User to identify any mechanical component(s) or system(s) that are either damaged or show obvious signs of wear requiring repairs.')}</label>
    <MySelect
      type="select"
      required={!props.disabled}
      disabled={props.disabled}
      style={props.disabled?disabledStyling:{}}
      value={props.upd.property.buildings[props.index].units[props.index2].mechanicalDeficiencies && props.upd.property.buildings[props.index].units[props.index2].mechanicalDeficiencies.length>0?" ":""}
      onChange={(v)=>updateMechanicalDeficiency(v)}
      options={mechanicalDeficiencyNameEnum}
    />
    {props.upd.property.buildings[props.index].units[props.index2].mechanicalDeficiencies.map(
      (mechanicalDeficiency, index)=>{
        if(mechanicalDeficiency.mechanicalDeficiencyName==='NONE_OBSERVED'){
          return <div key={index} style={{marginTop:'15px'}}>
            <b>None Observed</b>
          </div>
        }
        return (
          <div keyt={index}>
            <Card>
              <CardHeader><i className="fa fa-times red-color cursor-pointer" onClick={(e)=>removeMechanicalDeficiency(index)}/>{getMechanicalDeficiencyNameLabel(mechanicalDeficiency.mechanicalDeficiencyName)} Deficiency</CardHeader>
              <CardBody>
                <label>{!props.disabled?<font color="red">*</font>:null}What type of damage or wear did you observe? {generateTooltip('mechanicalDeficiencyType'+index,'User to identify the type of deficiency of the component selected.')}</label>
                <MySelect
                  type="select"
                  required={!props.disabled}
                  disabled={props.disabled}
                  style={props.disabled?disabledStyling:{}}
                  value={mechanicalDeficiency.mechanicalDeficiencyType}
                  onChange={(v)=>updateMechanicalDeficiencyDetail(index, 'mechanicalDeficiencyType', v)}
                  options={mechanicalDeficiencyTypeEnum}
                />
                <br/>
                <label>{!props.disabled?<font color="red">*</font>:null}Does the deficiency impact the safety, soundness or structural integrity of the structure or unit? {generateTooltip('mechanicalDeficiencySeverity'+index,'User to select whether the deficient item does or does not impact the safety, soundness or structural integrity of the affected structural component.')}</label>
                <MySelect
                  type="select"
                  required={!props.disabled}
                  disabled={props.disabled}
                  style={props.disabled?disabledStyling:{}}
                  value={mechanicalDeficiency.mechanicalDeficiencySeverity}
                  onChange={(v)=>updateMechanicalDeficiencyDetail(index, 'mechanicalDeficiencySeverity', v)}
                  options={[{label:"True",value:"True"},{label:"False",value:"False"}]}
                />
                <br/>
                <label>{!props.disabled?<font color="red">*</font>:null}Provide a concise description of each deficiency observed. {generateTooltip('mechanicalDeficiencyDescription'+index, 'User to provide a text description of any deficiencies observed.')}</label>
                <Input style={props.disabled?disabledStyling:{}} disabled={props.disabled} required={!props.disabled} type="text" value={mechanicalDeficiency.mechanicalDeficiencyDescription} onChange={(e)=>updateMechanicalDeficiencyDetail(index,'mechanicalDeficiencyDescription', e.target.value)}/>
                <br/>
                <label>{!props.disabled?<font color="red">*</font>:null}Image(s) of exterior deficiency</label>
                  <br/>
                  <input
                    tabIndex={-1}
                    autoComplete="off"
                    style={{ opacity: 0, height: 0, width:0 }}
                    value={mechanicalDeficiency.imageMechanicalDeficiency&&mechanicalDeficiency.imageMechanicalDeficiency.length>0?" ":""}
                    required={!props.disabled}
                  />
                  <div>
                    <Dropzone hidden={props.disabled} onDrop={(accepted, rejected)=>{onDrop(accepted, rejected, index, 'imageMechanicalDeficiency', mechanicalDeficiency.mechanicalDeficiencyName+'_MECHANICAL_DEFICIENCY', 0)}} className="my-dropzone">
                    {
                      ({getRootProps, getInputProps}) => (
                        <div
                          {...getRootProps({
                            className: 'my-dropzone',
                          })}
                        >
                          <input {...getInputProps()} />
                          <center>Choose files to upload</center>
                        </div>
                      )
                    }
                    </Dropzone>
                    {
                      !mechanicalDeficiency.imageMechanicalDeficiency?null:mechanicalDeficiency.imageMechanicalDeficiency.map(
                        (photo, index2)=>{
                          return <div key={index2} className="display-inline" style={{width:200, height:270, margin:5, verticalAlign:'top'}}>
                            <div>
                              <i hidden={props.disabled} className="fa fa-times red-color cursor-pointer" onClick={(e)=>removeFile('imageMechanicalDeficiency',index, index2)}/> {photo.name.length>16?photo.name.substr(0,16)+'...':photo.name}
                            </div>
                            <img alt="pic" width="200" height="200" src={photo.status==='Pending'?"data:image/png;base64, "+photo.base64:photo.presign_url}/>
                            {!photo.ID?<div><Input type="text" placeholder="Description of photo" value={photo.description} onChange={(e)=>updateFileDescription(index, index2, 'imageMechanicalDeficiency', e.target.value)}/>
                            <div style={{marginTop:'5px'}}/></div>:<i>{photo.description}</i>}
                          </div>
                        }
                      )
                    }
                  </div>
              </CardBody>
            </Card>
            <br/>
          </div>
        )
      })
    }
    <br/>

    <label>{!props.disabled?<font color="red">*</font>:null}Select any applicable mechanical component(s) that have been updated. {generateTooltip('mechanicalUpdate', 'Select all item(s) / component(s) that have been updated. If there have been no recent  updates select "None Observed".')}</label>
    <MySelect
      type="select"
      required={!props.disabled}
      disabled={props.disabled}
      style={props.disabled?disabledStyling:{}}
      value={props.upd.property.buildings[props.index].units[props.index2].mechanicalUpdates && props.upd.property.buildings[props.index].units[props.index2].mechanicalUpdates.length>0?" ":""}
      onChange={(v)=>updateMechanicalUpdate(v)}
      options={mechanicalUpdatedComponentEnum}
    />
    {props.upd.property.buildings[props.index].units[props.index2].mechanicalUpdates.map(
      (mechanicalUpdate, index)=>{
        if(mechanicalUpdate.mechanicalUpdatedComponent==='NONE_OBSERVED'){
          return <div key={index} style={{marginTop:'15px'}}>
            <b>None Observed</b>
          </div>
        }
        return (
          <div key={index}>
            <Card>
              <CardHeader><i className="fa fa-times red-color cursor-pointer" onClick={(e)=>removeMechanicalUpdate(index)}/> {getMechanicalUpdatedComponentLabel(mechanicalUpdate.mechanicalUpdatedComponent)} Update</CardHeader>
              <CardBody>
                <label>{!props.disabled?<font color="red">*</font>:null}Select to what degree  the mechanical component was updated. {generateTooltip('mechanicalUpdatedComponent'+index,'Indicate if the mechanical component has been fully updated or only partially updated. ')}</label>
                <MySelect
                  type="select"
                  required={!props.disabled}
                  disabled={props.disabled}
                  style={props.disabled?disabledStyling:{}}
                  value={mechanicalUpdate.mechanicalUpdateType}
                  onChange={(v)=>updateMechanicalUpdateDetail(index, 'mechanicalUpdateType', v)}
                  options={mechanicalUpdateTypeEnum}
                />
                <br/>
                <label>{!props.disabled?<font color="red">*</font>:null}How long ago was the update to the room completed? {generateTooltip('mechanicalUpdateTimeframe'+index,'User to select the approximate timeframe in which the update was completed. For instance, if an update was made approximately 3 years ago, then the user would select 1 to 5 years. ')}</label>
                <MySelect
                  type="select"
                  required={!props.disabled}
                  disabled={props.disabled}
                  style={props.disabled?disabledStyling:{}}
                  value={mechanicalUpdate.mechanicalUpdateTimeframe}
                  onChange={(v)=>updateMechanicalUpdateDetail(index, 'mechanicalUpdateTimeframe', v)}
                  options={mechanicalUpdateTimeframeEnum}
                />
                <br/>
                <label>{!props.disabled?<font color="red">*</font>:null}Provide a brief description of each mechanical update identified. {generateTooltip('mechanicalUpdateDescription'+index, 'User to provide a free form text description of the mechanical update(s) identified on the structure.')}</label>
                <Input style={props.disabled?disabledStyling:{}} disabled={props.disabled} required={!props.disabled} type="text" value={mechanicalUpdate.mechanicalUpdateDescription} onChange={(e)=>updateMechanicalUpdateDetail(index,'mechanicalUpdateDescription', e.target.value)}/>
                <br/>
                <label>{!props.disabled?<font color="red">*</font>:null}Image(s) of mechanical update</label>
                  <br/>
                  <input
                    tabIndex={-1}
                    autoComplete="off"
                    style={{ opacity: 0, height: 0, width:0 }}
                    value={mechanicalUpdate.imageMechanicalUpdate&&mechanicalUpdate.imageMechanicalUpdate.length>0?" ":""}
                    required={!props.disabled}
                  />
                  <div>
                    <Dropzone hidden={props.disabled} onDrop={(accepted, rejected)=>{onDrop2(accepted, rejected, index, 'imageMechanicalUpdate', mechanicalUpdate.mechanicalUpdatedComponent+'_MECHANICAL_UPDATE', 0)}} className="my-dropzone">
                    {
                      ({getRootProps, getInputProps}) => (
                        <div
                          {...getRootProps({
                            className: 'my-dropzone',
                          })}
                        >
                          <input {...getInputProps()} />
                          <center>Choose files to upload</center>
                        </div>
                      )
                    }
                    </Dropzone>
                    {
                      !mechanicalUpdate.imageMechanicalUpdate?null:mechanicalUpdate.imageMechanicalUpdate.map(
                        (photo, index2)=>{
                          return <div key={index2} className="display-inline" style={{width:200, height:270, margin:5, verticalAlign:'top'}}>
                            <div>
                              <i hidden={props.disabled} className="fa fa-times red-color cursor-pointer" onClick={(e)=>removeFile2('imageMechanicalUpdate',index, index2)}/> {photo.name.length>16?photo.name.substr(0,16)+'...':photo.name}
                            </div>
                            <img alt="pic" width="200" height="200" src={photo.status==='Pending'?"data:image/png;base64, "+photo.base64:photo.presign_url}/>
                            {!photo.ID?<div><Input type="text" placeholder="Description of photo" value={photo.description} onChange={(e)=>updateFileDescription2(index, index2, 'imageMechanicalUpdate', e.target.value)}/>
                            <div style={{marginTop:'5px'}}/></div>:<i>{photo.description}</i>}
                          </div>
                        }
                      )
                    }
                  </div>
              </CardBody>
            </Card>
            <br/>
          </div>
        )
      })
    }
    <br/>
  </div>
}


export default Mechanicals;